import { n as o } from "./nullToUndefined-Ba7Hd5zS.mjs";
function i(r, t) {
  return arguments.length === 2 ? o(
    // ONLY DO THIS IF YOU KNOW WHAT YOU ARE DOING
    // @ts-ignore
    r.reduce((e, n) => e ? e[n] : void 0, t)
  ) : (e) => o(
    // ONLY DO THIS IF YOU KNOW WHAT YOU ARE DOING
    // @ts-ignore
    r.reduce((n, d) => n ? n[d] : void 0, e)
  );
}
export {
  i as p
};
//# sourceMappingURL=path-Bvyc9DMw.mjs.map
